import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import GeneralFlipBooks from './GeneralFlipBooks.js';
import _ from 'lodash';
import { getFlipBookData } from '../../services/FlipBooks.js';
import FlipBook from './FlipBook.js';
import MyTabsNested from '../../components/MyTabsNested.js';

const EditFlipBookRecord = () => {
  const { alias } = useParams();
  const [flipBookTitle, setFlipBookTitle] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralFlipBooks, subTabs: [
        { id: "basic", title: "Basic", Component: FlipBook }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getFlipBookData(alias);

          if (result) {
            setFlipBookTitle(result?.data?.[0]?.name || result?.data?.[0]?.alias);
          }
        }
      } catch (error) {
        console.error('Error fetching Flip Book data:', error);
      }
    };

    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/flip-books/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
    <Stack py="5px">
      <Box px="4" pb="4">
        <Text fontSize={"22px"} fontWeight={"600"}>{_.capitalize(flipBookTitle)}</Text>
      </Box>
      <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/flip-books"} />
    </Stack>
  );
};

export default EditFlipBookRecord;